import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";
import { SiSitepoint } from "react-icons/si";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Tamirat Ayalew </span>
            known with the name вιηι, from <span className="purple"> Addis Ababa, Ethiopia.</span>
            <br /><br/><SiSitepoint /> Under graduate student in Adama Science and Technology University.
            <br /><SiSitepoint /> I have been on programming and computer things for the past years and I used to teach my self every thing online Apart from coding.
            <br />

            <SiSitepoint /> Some other activities that I love to do 
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Writting Tech Blogs
            </li>
            <li className="about-activity">
              <ImPointRight /> Watching Movies
            </li>
          </ul>

          <p style={{ marginBlockEnd: 0, color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">BiniTech</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
